// imports react-adal which has it's own node module
// documentatin on react-adal can be found at
// https://www.npmjs.com/package/react-adal
import { AuthenticationContext, adalFetch } from "react-adal";

import config from "config";

// Check
// Known lint issue as this a querystring parameter
export const adalConfig = {
	tenant: config.auth.tenantId,
	clientId: config.auth.appId,
	redirectUri: window.location.origin,
	postLogoutRedirectUri: window.location.href,
	endpoints: {
		api: config.auth.apiId,
	},
	cacheLocation: "localStorage",
};
export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
	adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);
